<template>
  <div
    v-loading="loading"
    class="l-page l-page--detail"
  >
    <div class="l-page__header c-page__header">
      <h2 class="c-page__header-title">
        新增维保项目
      </h2><div class="c-page__header-btns">
        <k-button
          btn-text="保存"
          :auth-type="false"
          type="primary"
          icon="kestrel-icon ki-save"
          @click="save"
        /><k-button
          btn-text="关闭"
          :auth-type="false"
          icon="kestrel-icon ki-close"
          @click="closeNavTabAndTo()"
        />
      </div>
    </div><div class="l-page__body l-page--detail__body">
      <hm-page-card class="c-card--detail">
        <el-form
          ref="form"
          :model="fd"
          :inline="true"
          label-suffix="："
          label-position="right"
          label-width="150px"
          class="c-form jxxf-project-form"
        >
          <el-row class="c-form__row">
            <el-col
              class="c-form__col c-form__part-title"
              :span="24"
            >
              项目基础信息
            </el-col><el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="委托单位"
                required
              >
                <el-input
                  v-model="fd.wtdwmc"
                  class="c-form__input"
                  placeholder="请输入委托单位"
                />
              </el-form-item>
            </el-col><el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="统一社会信用代码"
              >
                <el-input
                  v-model="fd.wtdwshxydm"
                  class="c-form__input"
                />
              </el-form-item>
            </el-col><el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="项目名称"
                required
              >
                <el-input
                  v-model="fd.xmmc"
                  class="c-form__input"
                />
              </el-form-item>
            </el-col><el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="签到要求"
                required
              >
                <el-radio-group v-model="fd.qdyq">
                  <el-radio label="0">
                    GPS签到
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col><el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="所属区域"
              >
                <select-address
                  v-model="fd.xzqydm"
                  required
                />
              </el-form-item>
            </el-col><el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="项目地址"
                required
              >
                <el-input
                  v-model="fd.xmdz"
                  class="c-form__input"
                  placeholder="用于现场签到定位"
                />
              </el-form-item>
            </el-col><el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="消防安全管理人"
              >
                <el-input
                  v-model="fd.xfaqglr"
                  class="c-form__input"
                />
              </el-form-item>
            </el-col><el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="联系电话"
              >
                <el-input
                  v-model="fd.xfaqglrdh"
                  class="c-form__input"
                />
              </el-form-item>
            </el-col><el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="物业管理单位"
              >
                <el-input
                  v-model="fd.wygldw"
                  class="c-form__input"
                />
              </el-form-item>
            </el-col><el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="维保单位"
                required
              >
                <el-input
                  v-model="fd.wbdwmc"
                  class="c-form__input"
                />
              </el-form-item>
            </el-col><el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                required
                class="c-form__item"
                label="合同名称"
              >
                <el-input
                  v-model="fd.htmc"
                  class="c-form__input"
                />
              </el-form-item>
            </el-col><el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                required
                class="c-form__item"
                label="合同编号"
              >
                <el-input
                  v-model="fd.htbh"
                  class="c-form__input"
                />
              </el-form-item>
            </el-col><el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                required
                class="c-form__item"
                label="合同有效期"
              >
                <hm-date-range
                  v-model="contractRange"
                  @change="syncContract"
                />
              </el-form-item>
            </el-col><el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="合同金额（元）"
              >
                <el-input-number
                  v-model="fd.htje"
                  :min="0"
                  :precision="2"
                />
              </el-form-item>
            </el-col><el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                required
                class="c-form__item"
                label="合同文件"
              >
                <file-serve-upload
                  v-model="fd.htfjId"
                  class="u-inline-block"
                  :file-api="$config.ctx.hmfileApi"
                  show-file-list
                  :data="uploadFd"
                  accept="application/pdf,application/msword,.doc,.docx"
                  :max-size="10 * 1024"
                >
                  <k-button
                    btn-text="上传"
                    :auth-type="false"
                    type="primary"
                    icon="kestrel-icon ki-cloud-upload"
                    plain
                  />
                </file-serve-upload><span class="u-text-warning">（支持 doc / docx / pdf，最大 10M）</span>
              </el-form-item>
            </el-col><el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="项目概况"
              >
                <el-input
                  v-model="fd.xmgs"
                  class="c-form__input"
                  type="textarea"
                  :rows="3"
                />
              </el-form-item>
            </el-col><el-col
              class="c-form__col c-form__part-title"
              :span="24"
            >
              建筑物信息
            </el-col><el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="建筑物名称"
                required
              >
                <el-input
                  v-model="fd.jzwList[0].jzwmc"
                  class="c-form__input"
                />
              </el-form-item>
            </el-col><el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="建筑物地址"
                required
              >
                <el-input
                  v-model="fd.jzwList[0].jzdz"
                  class="c-form__input"
                />
              </el-form-item>
            </el-col><el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="自动消防设施"
              >
                <el-radio-group v-model="fd.jzwList[0].zdxfss">
                  <el-radio label="Y">
                    有
                  </el-radio>
                  <el-radio label="N">
                    无
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col><el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="占地面积（m²）"
              >
                <el-input-number
                  v-model="fd.jzwList[0].zdmj"
                  :min="0"
                  :precision="2"
                  controls-position="right"
                />
              </el-form-item>
            </el-col><el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="建筑面积（m²）"
              >
                <el-input-number
                  v-model="fd.jzwList[0].jzmj"
                  :min="0"
                  :precision="2"
                  controls-position="right"
                />
              </el-form-item>
            </el-col><el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="建筑高度（m）"
              >
                <el-input-number
                  v-model="fd.jzwList[0].jzgd"
                  :min="0"
                  :precision="2"
                  controls-position="right"
                />
              </el-form-item>
            </el-col><el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="地上层数"
              >
                <el-input-number
                  v-model="fd.jzwList[0].dscs"
                  :min="0"
                  :precision="0"
                  controls-position="right"
                />
              </el-form-item>
            </el-col><el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="地下层数"
              >
                <el-input-number
                  v-model="fd.jzwList[0].dxcs"
                  :min="0"
                  :precision="0"
                  controls-position="right"
                />
              </el-form-item>
            </el-col><el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="安全出口数"
              >
                <el-input-number
                  v-model="fd.jzwList[0].aqcks"
                  :min="0"
                  :precision="0"
                  controls-position="right"
                />
              </el-form-item>
            </el-col><el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="疏散楼梯数"
              >
                <el-input-number
                  v-model="fd.jzwList[0].sslts"
                  :min="0"
                  :precision="0"
                  controls-position="right"
                />
              </el-form-item>
            </el-col><el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="消防电梯数"
              >
                <el-input-number
                  v-model="fd.jzwList[0].xfdts"
                  :min="0"
                  :precision="0"
                  controls-position="right"
                />
              </el-form-item>
            </el-col><el-col
              class="c-form__col c-form__part-title"
              :span="24"
            >
              维保信息
            </el-col><el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="项目负责人"
                required
              >
                <select-xm-user
                  v-model="fd.ryList[0].ryDm"
                  class="c-form__input"
                  role-code="JX-XMFZR"
                  :show-dept="false"
                />
              </el-form-item>
            </el-col><el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="技术负责人"
                required
              >
                <select-xm-user
                  v-model="fd.ryList[1].ryDm"
                  class="c-form__select"
                  role-code="JX-JSRY"
                  :show-dept="false"
                />
              </el-form-item>
            </el-col><el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="维保设施系统"
                required
              >
                <el-checkbox-group v-model="fd.ssflIds">
                  <el-checkbox
                    v-for="item in facilities"
                    :key="item.uuid"
                    :label="item.uuid"
                  >
                    {{ item.ssmc }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </hm-page-card>
    </div>
  </div>
</template>
<script>
import { projectService } from './project.service';
export default {
  name: 'JxxfWbProjectForm',
  data () {
    return {
      loading: false,
      editMode: false,
      facilities: [],
      contractRange: [],
      uploadFd: { meta: [{ key: 'type', value: 'jxxfwbht' }] },
      fd: {
        qdyq: '0',
        xzqydm: '',
        xmdz: '',
        htfjId: '',
        jzwList: [{ jzwmc: '', jzdz: '', dscs: 0, dxcs: 0 }],
        ryList: [
          { ryDm: '', ryjs: 'XMFZR', sfzy: 'Y' },
          { ryDm: '', ryjs: 'JSFZR', sfzy: 'Y' }
        ],
        ssflIds: []
      }
    };
  },
  methods: {
    syncContract (value) {
      this.fd.htyxqQ = value && value[0];
      this.fd.htyxqZ = value && value[1];
    },
    save () {
      this.loading = true;
      const uploadValue = Array.isArray(this.fd.htfjId) ? this.fd.htfjId[0] : this.fd.htfjId;
      const payload = Object.assign({}, this.fd, {
        htyxqQ: this.contractRange && this.contractRange[0] ? this.contractRange[0] : this.fd.htyxqQ,
        htyxqZ: this.contractRange && this.contractRange[1] ? this.contractRange[1] : this.fd.htyxqZ,
        htfjId: uploadValue && typeof uploadValue === 'object'
          ? (uploadValue.id || uploadValue.fileId)
          : uploadValue
      });
      const request = this.editMode
        ? projectService.update(this.$route.params.xmId, payload)
        : projectService.create(payload);
      request.then(() => {
        this.$message.success(this.editMode ? '项目修改成功' : '项目创建成功');
        this.closeNavTabAndTo({
          name: 'jxxfWbProjectIndex',
          params: { isRefresh: true }
        }, true);
      }).finally(() => {
        this.loading = false;
      });
    },
    loadFacilities () {
      projectService.facilities().then(rsp => {
        this.facilities = rsp.data;
      });
    },
    /** 加载已有江西维保项目并转换为编辑表单数据。 */
    loadProject () {
      this.loading = true;
      projectService.detail(this.$route.params.xmId).then(rsp => {
        const data = rsp.data || {};
        this.fd = Object.assign({}, this.fd, data, {
          jzwList: data.jzwList && data.jzwList.length ? data.jzwList : this.fd.jzwList,
          ryList: data.ryList && data.ryList.length ? data.ryList : this.fd.ryList,
          ssflIds: (data.ssflList || []).map(item => item.uuid)
        });
        this.contractRange = [data.htyxqQ, data.htyxqZ];
      }).finally(() => {
        this.loading = false;
      });
    }
  },
  created () {
    this.loadFacilities();
    if (this.$route.params.xmId) {
      this.editMode = true;
      this.loadProject();
    }
  }
};
</script>

<style lang="scss">
.jxxf-project-form {
  .el-input,
  .el-input-number,
  .el-select {
    width: 100%;
  }
}
</style>
